import { useMemo } from 'react';
import { useDataModel } from '@thd-nucleus/data-sources';
import { PromoModelProviderDataModel } from '../models/PromoModelProviderDataModel';

export const usePromotionProductsPage = ({
  promotion,
  eligibilityCriterion,
  startIndex,
  disablePagination,
  rewardDrawerMaxLength,
  totalProducts,
}) => {
  const promotionId = promotion?.promotionId;
  const purchaseRequirementGroup = eligibilityCriterion?.itemGroup;
  const drawerCountLimit = Math.min(totalProducts, rewardDrawerMaxLength);
  const remainingNumProducts = Math.max(drawerCountLimit - startIndex, 0);
  const pageSize = Math.min(remainingNumProducts, 16);
  const skip = !pageSize || !startIndex || disablePagination;

  const graphQlOptions = useMemo(() => {
    return {
      variables: {
        pageSize,
        promotionId,
        purchaseRequirementGroup,
        startIndex,
      },
      skip,
      dataModel: PromoModelProviderDataModel
    };
  }, [
    pageSize,
    promotionId,
    purchaseRequirementGroup,
    startIndex,
    skip,
  ]);

  const { data, loading } = useDataModel('promotionProductsPage', graphQlOptions);

  return useMemo(() => {
    const pageItemIds = data?.promotionProductsPage?.itemIds || [];

    return {
      pageItemIds,
      loading,
    };
  }, [data, loading]);
};
